import '@northeastern-web/kernl-ui';
import TextToSVG from 'text-to-svg';

import './highlight.js';
import './colors.js';

window.TextToSVG = TextToSVG;

window.resizableIFrame = require('./alpine/resizable-iframe.js').default;
window.navSection = require('./alpine/nav-section.js').default;

Alpine.$on = function(event, callback) {
    window.addEventListener(event, callback);
};

Alpine.$dispatch = function(event, params) {
    var event = new CustomEvent(event, {
        bubbles: true,
        cancelable: true,
        detail: params,
    });

    window.dispatchEvent(event);
};

window.tinycolor = require('tinycolor2');

// Wrap headings in link elements
[
    ...document.querySelectorAll(
        '.DocSearch-content h2, .DocSearch-content h3, .DocSearch-content h4, .DocSearch-content h5, .DocSearch-content h6'
    ),
].forEach(heading => {
    const newHeading = heading.cloneNode(true);

    if (!heading.id) {
        return;
    }

    const link = document.createElement('a');

    newHeading.id = heading.id;
    newHeading.textContent = '';

    link.href = `#${heading.id}`;
    link.textContent = heading.textContent;

    newHeading.appendChild(link);

    heading.insertAdjacentElement('beforeBegin', newHeading);
    heading.remove();
});
